export const colors = {
  dark: '#353535',
  light: '#FDF5ED',
  orange: '#FFC783',
  pink: '#FBABA7',
  purple: '#EEC3F2',
  blue: '#B7D2EC',
  turquoise: '#B7E9EC',
}
